<template>
  <div class="shebeiM">
    <div class="left">
      <div class="title">配电室列表</div>
      <el-collapse v-model="activeName" accordion @change="handleChange">
        <el-collapse-item
          v-for="(item, index) in roomList"
          :key="index"
          :name="index"
        >
          <template slot="title">
            <div :title="item.roomName" class="collapse-title">
              <img src="../../assets/images/iconele.png" alt="" />
              <div class="sspan">
                {{ item.roomName }}
              </div>
            </div>
          </template>
          <operation
            :title="'高压柜'"
            :rootData="item"
            :data="item.cabinetTypeList[0]"
            :type="1"
            @deleteItem="delCabinet"
            @addItem="addMainCabinet"
            @upItem="updateCabinetNum"
          ></operation>
          <operation
            :title="'低压柜'"
            :rootData="item"
            :data="item.cabinetTypeList[1]"
            :type="2"
            @deleteItem="delCabinet"
            @addItem="addMainCabinet"
            @upItem="updateCabinetNum"
          ></operation>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="right">
      <div class="gao">
        <div class="title">高压回路柜配置</div>
        <div class="box">
          <div class="item1" v-if="roomList.length > 0">
            <operation
              :title="'高压主进柜'"
              :rootData="roomList[rightIndex]"
              :data="roomList[rightIndex].cabinetTypeList[0]"
              :type="1"
              @deleteItem="delCabinet"
              @addItem="addMainCabinet"
              @upItem="updateCabinetNum"
              @setItem="setItem"
            ></operation>
          </div>
          <div class="you">
            <i class="iconfont icon-you"></i>
          </div>
          <div class="item2" v-if="roomList.length > 0">
            <operation2
              :title="'高压回路柜'"
              :rootData="roomList[rightIndex]"
              :data="roomList[rightIndex].cabinetTypeList[2]"
              :type="3"
              :rightIndexId="rightIndexId"
              @deleteItem="delCabinet"
              @addItem="addLoopCabinet"
              @upItem="updateCabinetNum"
            ></operation2>
          </div>
        </div>
      </div>
      <div class="gao section2">
        <div class="title">低压回路柜配置</div>
        <div class="box">
          <div class="item1" v-if="roomList.length > 0">
            <operation
              :title="'低压主进柜'"
              :rootData="roomList[rightIndex]"
              :data="roomList[rightIndex].cabinetTypeList[1]"
              :type="2"
              @deleteItem="delCabinet"
              @addItem="addMainCabinet"
              @upItem="updateCabinetNum"
              @setItem="setItem2"
            ></operation>
          </div>
          <div class="you">
            <i class="iconfont icon-you"></i>
          </div>
          <div class="item2" v-if="roomList.length > 0">
            <operation2
              :title="'低压回路柜'"
              :rootData="roomList[rightIndex]"
              :data="roomList[rightIndex].cabinetTypeList[3]"
              :type="4"
              :rightIndexId="rightIndexId2"
              @deleteItem="delCabinet"
              @addItem="addLoopCabinet"
              @upItem="updateCabinetNum"
            ></operation2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 1高压主进，2低压主进，3高压回路，4低压回路

import {
  Message
} from 'element-ui';
import operation from "./setUp";
import operation2 from "./setUp2";
export default {
  components: {
    operation,
    operation2,
  },
  data() {
    return {
      id: "",
      activeName: "",
      roomList: [],
      rightIndex: 0,
      rightIndexId: "",
      rightIndexId2: "",
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.searchRoomCabinetList(1);
  },
  methods: {
    searchRoomCabinetList(type) {
      this.$http
        .post(
          "bma-distribution-service/equipmentCabinet/searchRoomCabinetList",
          {
            projectId: this.id,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            this.roomList = res.data;
            if (type == 1) {
              if (res.data) {
                this.activeName = 0;
              }
            }
          }
        });
    },
    // 增加主进柜
    addMainCabinet(id, type, Num) {
      this.$http
        .post("bma-distribution-service/equipmentCabinet/addMainCabinet", {
          cabinetNum: Num,
          cabinetType: type,
          roomId: id,
        })
        .then((res) => {
          if (res.code == 200) {
            Message("增加成功");
          }
          this.searchRoomCabinetList();
        });
    },
    // 修改配电柜名称（编号）
    updateCabinetNum(id, input) {
      console.log(id, input);
      this.$http
        .post("bma-distribution-service/equipmentCabinet/updateCabinetNum", {
          cabinetNum: input,
          cabinetId: id,
        })
        .then((res) => {
          console.log("修改", res);
          if (res.code == 200) {
            Message("修改成功");
            this.searchRoomCabinetList();
          }
        });
    },
    handleChange(val) {
      this.rightIndex = val;
    },
    // 增加回路柜
    addLoopCabinet(rid, pid, type, input) {
      this.$http
        .post("bma-distribution-service/equipmentCabinet/addLoopCabinet", {
          cabinetNum: input,
          cabinetType: type,
          parentCabinetId: pid,
          roomId: rid,
        })
        .then((res) => {
          console.log("增加回路", res);
          if (res.code == 200) {
            Message("新增成功");
            this.searchRoomCabinetList();
          }
        });
    },
    // 删除
    delCabinet(id) {
      console.log(id);
      this.$http
        .post("bma-distribution-service/equipmentCabinet/delCabinet", {
          cabinetId: id,
        })
        .then((res) => {
          if (res.code == 200) {
            Message("删除成功");
            this.searchRoomabinetList();
          }
        });
    },
    setItem(i) {
      this.rightIndexId = i;
    },
    setItem2(i) {
      this.rightIndexId2 = i;
    },
  },
};
</script>

<style lang="less" scoped>
.shebeiM {
  display: flex;
  .left {
    width: 337px;
    height: 1047px;
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
    .title {
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 2px;
      margin-bottom: 10px;
      text-align: left;
    }
    /deep/.el-collapse {
      .el-collapse-item__header {
        .collapse-title {
          display: flex;
          align-items: center;
          img {
            width: 20px;
            margin-right: 8px;
          }
          .sspan {
            width: 220px;
            font-size: 14px;
            text-indent: 0px;
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .right {
    margin-left: 15px;
    width: 1285px;
    height: 1077px;
    .gao {
      background: #fff;
      height: 512px;
      padding: 20px;
      box-sizing: border-box;
      &.section2 {
        margin-top: 20px;
      }
      .title {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 2px;
        margin-bottom: 30px;
      }
      .box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item1 {
          width: 373px;
          height: 407px;
          border: 1px solid #e7e7e7;
          padding: 20px;
          padding-top: 0;
          box-sizing: border-box;
        }
        .you {
          color: rgba(33, 105, 225, 1);
          i {
            font-size: 40px;
          }
        }
        .item2 {
          width: 660px;
          height: 407px;
          border: 1px solid #e7e7e7;
          padding: 20px;
          padding-top: 0;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>